import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import classNames from "classnames";
import history from "history.js";
import MobileDetect from "mobile-detect";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import clsx from "clsx";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText
    },
    content: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 10,
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,'Helvetica',Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: "70px",
    },
    bgTheme: {
        backgroundColor: theme.palette.primary.main
    }
});

class Organizacao extends XAPPComponent {

    componentDidMount() {
        const { organizacoes } = this.props;
        if (_.isUndefined(organizacoes) || _.isNull(organizacoes)) {
            history.push("/pub-login");
        }
    }

    selectOrganizacao = (_AItem) => {
        const { location } = this.props;
        sessionStorage.setItem("organizacao", _AItem.id);

        var APath = _AItem.url_ui;
        if (!_.isUndefined(location.search)) {
            APath = APath + "&" + location.search.substring(1);
        }
        document.location.href = APath;
    }

    render() {
        const { classes, theme, organizacoes } = this.props;

        return (
            <React.Fragment>
                <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-0 md:flex-row")}>
                    <div className="flex flex-col w-full items-center justify-center mt-12">
                        <img
                            className={clsx(classes.bgTheme, "justify-center mb-16 h-52")}
                            src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                            alt="Logo principal"
                        />
                        <div >
                            <span className={classes.spanlabel}>{"Organizações"}</span>
                            <div className={classNames(classes.content, "flex items-center justify-center p-28 md:p-56 mx-6 md:mx-0")}>
                                <div className={"flex w-full items-center justify-center md:flex-row flex-wrap"}>
                                    {!_.isUndefined(organizacoes) && !_.isNull(organizacoes) && organizacoes.map(item => (
                                        <XAPPButton
                                            key={item.id}
                                            type="Card"
                                            className={classNames(classes.btnOrganizacao, "text-white")}
                                            color="primary"
                                            iconProps={"justify-center text-40"}
                                            icon={"building"}
                                            onClick={() => this.selectOrganizacao(item)}
                                            label={item.nome}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        theme: fuse.settings.mainTheme,
        organizacoes: auth.user.organizacoes,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(Organizacao)));
